// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Background and Container */
.info-section {
    /* background-image: url('/path/to/background-image.jpg');  */
    background-size: cover;
    background-position: center;
    padding: 60px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .info-container {
    background-color: rgba(255, 255, 255, 0.9);
    padding: 40px;
    border-radius: 8px;
    max-width: 500px;
    width: 100%;
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
    text-align: center;
  }
  
  /* Title and Description */
  .info-title {
    font-size: 28px;
    font-weight: 700;
    color: #333;
    margin-bottom: 15px;
  }
  
  .info-description {
    font-size: 16px;
    color: #666;
    margin-bottom: 30px;
  }
  
  /* Form Group */
  .form-group {
    margin-bottom: 20px;
  }
  
  .form-label {
    display: block;
    font-size: 14px;
    color: #333;
    margin-bottom: 8px;
    text-align: left;
  }
  
  .form-input {
    width: 100%;
    padding: 14px;
    border-radius: 4px;
    border: 1px solid #ccc;
    font-size: 16px;
    box-sizing: border-box;
    background-color: #f7f7f7;
  }
  
  /* Button Styling */
  .info-button {
    background-color: #0071bc;
    color: #fff;
    padding: 14px 20px;
    border: none;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.3s ease;
    width: 100%;
    text-transform: uppercase;
  }
  
  .info-button:hover {
    background-color: #005fa3;
  }
  
  /* Message Styling */
  .form-message {
    margin-top: 20px;
    font-size: 14px;
    color: #333;
  }
  `, "",{"version":3,"sources":["webpack://./src/Components/MoreInfoSection/MoreInfoSection.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;IACI,6DAA6D;IAC7D,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,0CAA0C;IAC1C,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,4CAA4C;IAC5C,kBAAkB;EACpB;;EAEA,0BAA0B;EAC1B;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,mBAAmB;EACrB;;EAEA,eAAe;EACf;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,sBAAsB;IACtB,yBAAyB;EAC3B;;EAEA,mBAAmB;EACnB;IACE,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,sCAAsC;IACtC,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,oBAAoB;EACpB;IACE,gBAAgB;IAChB,eAAe;IACf,WAAW;EACb","sourcesContent":["/* Background and Container */\n.info-section {\n    /* background-image: url('/path/to/background-image.jpg');  */\n    background-size: cover;\n    background-position: center;\n    padding: 60px 20px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  .info-container {\n    background-color: rgba(255, 255, 255, 0.9);\n    padding: 40px;\n    border-radius: 8px;\n    max-width: 500px;\n    width: 100%;\n    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);\n    text-align: center;\n  }\n  \n  /* Title and Description */\n  .info-title {\n    font-size: 28px;\n    font-weight: 700;\n    color: #333;\n    margin-bottom: 15px;\n  }\n  \n  .info-description {\n    font-size: 16px;\n    color: #666;\n    margin-bottom: 30px;\n  }\n  \n  /* Form Group */\n  .form-group {\n    margin-bottom: 20px;\n  }\n  \n  .form-label {\n    display: block;\n    font-size: 14px;\n    color: #333;\n    margin-bottom: 8px;\n    text-align: left;\n  }\n  \n  .form-input {\n    width: 100%;\n    padding: 14px;\n    border-radius: 4px;\n    border: 1px solid #ccc;\n    font-size: 16px;\n    box-sizing: border-box;\n    background-color: #f7f7f7;\n  }\n  \n  /* Button Styling */\n  .info-button {\n    background-color: #0071bc;\n    color: #fff;\n    padding: 14px 20px;\n    border: none;\n    border-radius: 4px;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    width: 100%;\n    text-transform: uppercase;\n  }\n  \n  .info-button:hover {\n    background-color: #005fa3;\n  }\n  \n  /* Message Styling */\n  .form-message {\n    margin-top: 20px;\n    font-size: 14px;\n    color: #333;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
